<nb-accordion multi kwExpandFirstItem>
    <nb-accordion-item expanded>
        <nb-accordion-item-header>Toggle Header Rows</nb-accordion-item-header>
        <nb-accordion-item-body>
            <div class="input-cell">
                <nb-toggle labelPosition="start"  (checkedChange)="onChangeTopRow($event)" [checked]="false">Top Row</nb-toggle>
                <nb-toggle labelPosition="start" [checked]="true" disabled>Main Row</nb-toggle>
                <nb-toggle labelPosition="start" (checkedChange)="onChangeBottomRow($event)" [checked]="false">Bottom Row</nb-toggle>
            </div>
        </nb-accordion-item-body>
    </nb-accordion-item>
    <nb-accordion-item *ngFor="let field of fields;let i = index">
        <nb-accordion-item-header>{{field?.title}}</nb-accordion-item-header>
        <nb-accordion-item-body>
            <kve-field-editor [field]="field" (updateField)="onFieldUpdate($event)"></kve-field-editor>
        </nb-accordion-item-body>
    </nb-accordion-item>
</nb-accordion>



